import { useState } from 'react';
import ModalShell from '../ModalShell';
import ProjectShowcase from './ProjectShowcase';
import artGalleryProjects from './artGalleryProjects';
import './ArtGalleryModal.css';

// Layout for the "3D Art & Animations" project: a selectable row of project
// previews (between the modal title and the showcase), followed by the
// ProjectShowcase for whichever project is currently selected. Only one
// project's showcase is rendered at a time, so its media column (which can
// vary in length per project) stays fully responsive. Edit
// artGalleryProjects.js to add or update entries.
function ArtGalleryModal({ project, onClose }) {
  const [selectedIndex, setSelectedIndex] = useState(0);
  const selectedProject = artGalleryProjects[selectedIndex];

  return (
    <ModalShell contentClassName="modal-shell__content--art-gallery" titleId="art-gallery-modal-title" onClose={onClose}>
      <div className="art-gallery-modal">
        <div className="art-gallery-modal__intro">
          <p className="eyebrow">3D art gallery</p>
          <h2 id="art-gallery-modal-title">{project.title}</h2>
        </div>

        {artGalleryProjects.length > 1 && (
          <div className="art-gallery-modal__projects">
            {artGalleryProjects.map((item, index) => {
              const previewThumbnail = item.previewThumbnail || item.media?.[item.media.length - 1]?.thumbnail;

              return (
                <button
                  className={`art-gallery-modal__project${index === selectedIndex ? ' art-gallery-modal__project--active' : ''}`}
                  key={item.title}
                  onClick={() => setSelectedIndex(index)}
                  type="button"
                >
                  <span className="art-gallery-modal__project-media">
                    {previewThumbnail && <img alt="" src={previewThumbnail} />}
                  </span>
                  <span className="art-gallery-modal__project-label">{item.title}</span>
                </button>
              );
            })}
          </div>
        )}

        {selectedProject?.type === 'sketchfab' && (
          <section className="art-gallery-modal__sketchfab" aria-labelledby="windmill-island-title">
            <h3 id="windmill-island-title">{selectedProject.title}</h3>
            <div className="sketchfab-embed-wrapper">
              <iframe
                allow="autoplay; fullscreen; xr-spatial-tracking"
                allowFullScreen
                loading="lazy"
                src={selectedProject.embedUrl}
                title="Windmill Island Gorillaz"
              />
              <p>
                <a href={selectedProject.modelUrl} target="_blank" rel="nofollow noreferrer">
                  Windmill Island Gorillaz
                </a>
                {' by '}
                <a href={selectedProject.authorUrl} target="_blank" rel="nofollow noreferrer">
                  gfloresb09
                </a>
                {' on '}
                <a href="https://sketchfab.com" target="_blank" rel="nofollow noreferrer">
                  Sketchfab
                </a>
              </p>
            </div>
          </section>
        )}

        {selectedProject && selectedProject.type !== 'sketchfab' && (
          <ProjectShowcase
            key={selectedProject.title}
            title={selectedProject.title}
            tools={selectedProject.tools}
            media={selectedProject.media}
          />
        )}
      </div>
    </ModalShell>
  );
}

export default ArtGalleryModal;
